import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const List = styled.ul`
  display: none;

  &:focus {
    outline: none;
  }
`;

export const Title = styled.label`
  margin-bottom: ${props => props.theme.space(2)};
  cursor: pointer;
  line-height: ${props => props.theme.rem(16)};
  text-transform: capitalize;
  user-select: none;
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.space(2)};

  .open {
    transform: rotate(-180deg);
  }

  svg {
    transition: all 0.25s ease;
    align-self: center;
  }

  &:not(:last-of-type) {
    margin-right: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: ${props => props.theme.rem(16)};
  color: ${props => props.theme.dropdown.containerColor};
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  user-select: none;

  > input {
    display: none;

    &[type='checkbox']:checked ~ ${List} {
      display: block;
      max-height: initial;
      height: auto;
      width: 215px;
      z-index: 2;

      li {
        &:hover a {
          border: none;
        }
      }
    }
  }

  input[type='checkbox']:checked + ${Title} {
    position: relative;

    &:after {
      transform: rotate(-45deg);
    }

    &:before {
      transform: rotate(45deg);
    }
  }

  &:focus {
    outline: none;
  }
`;

export const Item = styled.li`
  margin-right: 0 !important;
  user-select: none;
  font-weight: 400;

  &:focus,
  &:hover {
    font-family: IntervalNextReg, sans-serif;
    font-weight: 600;
    outline: none;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -1px;
      width: 3px;
      height: ${props => props.theme.space(8)};
      background-color: ${props => props.theme.dropdown.selectedColor};
    }
  }

  &.selected {
    button,
    a {
      font-family: IntervalNextReg, sans-serif;
      font-weight: 600;
    }
  }

  button,
  a {
    font-family: IntervalNextReg, sans-serif;
    display: flex;
    align-items: center;
    height: ${props => props.theme.space(8)};
    width: 100%;
    border: 0;
    padding-left: ${props => props.theme.space(5)};
    justify-content: left;
    font-size: ${props => props.theme.rem(14)};
    text-decoration: none;
    text-align: left;
    color: ${props => props.theme.dropdown.color};
    background: none;
    cursor: pointer;
    position: relative;
    user-select: none;

    &:focus,
    &:hover {
      outline: none;
      font-weight: 600;
    }
  }

  ${mediaMin.smallBreakpoint`
    &:focus,
    &:hover {
      &:before {
        width: 0;
      }
    }
  `}
`;

export const Separator = styled.li`
  height: 1px;
  background-color: ${props => props.theme.dropdown.itemColor};
  margin-block-end: ${props => props.theme.space(3)};
`;
